import request from '@/utils/request'
import { ResponseData } from './modular'
import md5 from 'md5'
/**
 * @description: 获取提款列表
 * @param {*} data.page
 * @param {*} data.pageSize
 * @return {*}
 */
export const getWithdrawList = (data: any) => {
  return request<ResponseData<any>>('/web/getPlayerAccounts', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 绑定 usdt 账号
 * @param {*}
 * @return {*}
 */
export const bindUsdtAccount = (data: any) => {
  return request<ResponseData<any>>('/web/createPlayerAccounts', {
    method: 'POST',
    data,
  })
}

/**
 * @description: 获取支付通道
 * @param {*}
 * @return {*}
 */
export const getPayChannel = () => {
  return request<ResponseData<any>>('/web/getPayments', {
    method: 'GET',
  })
}

/**
 * @description: 删除提款账号
 * @param {*}
 * @return {*}
 */
export const deleteWithdrawAccount = (params: any) => {
  return request<ResponseData<any>>('/web/deleteAccount', {
    method: 'DELETE',
    params,
  })
}

/**
 * @description: 获取充值列表
 * @param {*}
 * @return {*}
 */
export const getDepositList = (data: any) => {
  return request<ResponseData<any>>('/web/getPayRecords', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 获取提现列表
 * @param {*}
 * @return {*}
 */
export const getWithdrawPayList = (data: any) => {
  return request<ResponseData<any>>('/web/getPlayerWithdrawals', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 申请提现
 * @param {*}
 * @return {*}
 */
export const applyWithdraw = (data: any) => {
  return request<ResponseData<any>>('/web/applyWithdrawal', {
    method: 'POST',
    data: {
      ...data,
      payPassword: md5(`${data.payPassword}`),
    },
  })
}

/**
 * @description: 创建支付订单
 * @param {*}
 * @return {*}
 */
export const createPayOrder = (data: any) => {
  return request<ResponseData<any>>('/web/pay', {
    method: 'POST',
    data,
  })
}
/**
 * @description: 获取所有货币
 * @param {*}
 * @return {*}
 */
export const getCurrencyList = (data: any) => {
  return request<ResponseData<any>>('/web/getCurrencies', {
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 预提现计算金额
 * @param {*}
 * @return {*}
 */
export const getWithdrawAmount = (data: any) => {
  return request<ResponseData<any>>('/web/calcReceiveAmount', {
    method: 'POST',
    data,
  })
}

/**
 * @description: 计算充值平台金额
 * @param {*}
 * @return {*}
 */
export const getDepositAmount = (data: any) => {
  return request<ResponseData<any>>('/web/calcRealAmount', {
    method: 'POST',
    data,
  })
}

/**
 * @description: 回收余额
 * @param {*}
 * @return {*}
 */
export const refreshBalance = () => {
  return request<ResponseData<any>>('/web/gameCleanAll', {
    method: 'PUT',
  })
}

/**
 * @description: 订单支付查询
 * @param {*}
 * @return {*}
 */
export const getPayOrder = (data: any) => {
  return request<ResponseData<any>>('/web/findPayRecord', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 立即支付账单
 * @param {*}
 * @return {*}
 */
export const payBill = (data: any) => {
  return request<ResponseData<any>>('/web/pay/notManual', {
    method: 'POST',
    data,
  })
}

/**
 * @description: 手动支付账单
 * @param {*}
 * @return {*}
 */
export const payBillManual = (data: any) => {
  return request<ResponseData<any>>('/web/pay/manual', {
    method: 'POST',
    data,
  })
}

/**
 * @description: 获取游戏余额列表
 * @param {*}
 * @return {*}
 */
export const getGameBalanceList = () => {
  return request<ResponseData<any>>('/web/getGameAccounts', {
    method: 'GET',
  })
}

/**
 * @description: usdt 自动支付
 * @param {*}
 * @return {*}
 */
export const usdtAutoPay = (data: any) => {
  return request<ResponseData<any>>('/web/pay/usdt', {
    method: 'POST',
    data,
  })
}
